/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
// import config from "../config/revokeCallout.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { REVOKE_CALLOUT_TOKEN } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import moment from "moment";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const storageService = StorageModule.getInstance();
const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IRevokeCalloutMethods extends IPluginMethodMap {
  revokeCallout(args: any): Promise<any>;
}

export class RevokeCalloutService implements IAgentPlugin {
  readonly methods: IRevokeCalloutMethods;

  constructor() {
    this.methods = {
      revokeCallout: this.revokeCallout.bind(this),
    };
  }

  async revokeCallout(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    //return {...(config)}
    const distCenterData = storageService.get("distCenterData", "local");
    console.log(`bla distCenterData in payment service`, distCenterData);
    try {
      if (client) {
        const res = await client.mutate({
          mutation: REVOKE_CALLOUT_TOKEN,
          variables: {
            counter: distCenterData?.paymentCounter,
            tokenKey: args?.tokenKey,
            isCalledOut: false,
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data) {
          console.log(`payment queue data`, res.data);
          // toast.success("Token called out");
          return {
            ...res?.data?.qCallOutByDistCounter,
          };
        }
      }
    } catch (err: any) {
      toast.error("Failed in calling out token");
      throw err;
    }
    // return {...(config || {})}
  }
}
